import React from "react";
import PropTypes from "prop-types";

import { faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SimpleList from "components/SimpleList";

import { useDragDropContext } from "../../../../hooks";

function NextWorkflowItem({
  disabled,
  enableDnd,
  nextWorkflow,
  beingDeleted,
  options,
  onDelete,
}) {
  const [{ getCursor }] = useDragDropContext();

  return (
    <SimpleList.Item data-test="next-workflow-item">
      {!disabled && enableDnd && (
        <div
          data-test="nextWorkflow-drag-handle"
          style={{
            alignSelf: "flex-start",
            marginTop: "0.1em",
          }}
        >
          <FontAwesomeIcon
            className="dark_grey_on_hover nextWorkflow-drag-handle"
            color="rgb(218, 218, 218)"
            icon={faGripVertical}
            style={{
              marginLeft: "0.5em",
              cursor: getCursor(),
            }}
          />
        </div>
      )}
      <div style={{ flexGrow: 1 }}>{nextWorkflow.name}</div>
      <div style={{ display: "flex", gap: "0.4em" }}>
        {options}
        {beingDeleted ? (
          <SimpleList.Spinner />
        ) : (
          !disabled && <SimpleList.DeleteButton onClick={onDelete} />
        )}
      </div>
    </SimpleList.Item>
  );
}

NextWorkflowItem.propTypes = {
  nextWorkflow: PropTypes.object.isRequired,
  beingDeleted: PropTypes.bool,
  disabled: PropTypes.bool,
  enableDnd: PropTypes.bool,
  options: PropTypes.node,
  onDelete: PropTypes.func.isRequired,
};

NextWorkflowItem.defaultProps = {
  beingDeleted: false,
  disabled: false,
  options: undefined,
  enableDnd: false,
};

export default NextWorkflowItem;
